import React from 'react'
import './fileuploader.scss'

import Stack from '@mui/material/Stack'
import StatusContext from '../../../contexts/StatusContext';
import AttachFileIcon from '@mui/icons-material/AttachFile';


export const AttachFile = ({onClick}) => {

   const {
        changeLanguage,
    } = React.useContext(StatusContext);


  return (
  
          <div className="attachfile" onClick={() => { onClick() }}>

            <Stack direction="row">

              <AttachFileIcon sx={{color:'maroon', padding:'3px'}} />
              <div style={{ color: 'maroon' }}>
                {changeLanguage('documentanalysis', 'attachfile')}
              </div>
            </Stack>

          </div>

  )
}